/**
 * 创建人：yjs
 * 创建时间：2020-09-14
 * 描述：根据后缀返回对应的文件类型图片地址
 * 更新记录: 
 */
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GetSuffixImgService {

  constructor() { }

  /**
   * 获取用户信息
   * @param suffix  文件后缀
   * @returns src
   */
  getFileTypeImg(fileSuffix){
    let src
    if(fileSuffix == 'jpg' || fileSuffix == 'jpeg' || fileSuffix == 'bmp' || fileSuffix == 'png' || fileSuffix == 'gif'){
      //图片
      src = 'assets/Images/files/img.png'
    } else if(fileSuffix == 'docx' || fileSuffix == 'doc'){ 
      // 文档
      src = 'assets/Images/files/doc.png'
    }else if(fileSuffix == 'xls' || fileSuffix == 'xlsx'){
      // excel
      src = 'assets/Images/files/xls.png'
    }else if(fileSuffix == 'pdf'){
      // pdf
      src = 'assets/Images/files/pdf.png'
    }else if(fileSuffix == 'mp3' || fileSuffix == 'wma' || fileSuffix == 'rm' || fileSuffix == 'mpg' || fileSuffix == 'mov' || fileSuffix == 'mkv' || fileSuffix == 'wav' || fileSuffix == 'cda'){
      // 音频
      src = 'assets/Images/files/audio.png'
    }else if(fileSuffix == 'mp4' || fileSuffix == 'avi' || fileSuffix == 'flv' || fileSuffix == 'ogg' || fileSuffix == 'wmv' || fileSuffix == 'asf' || fileSuffix == 'mpg' || fileSuffix == '3gp' || fileSuffix == 'rmvb'){
      // 视频
      src = 'assets/Images/files/video.png'
    }else if(fileSuffix == 'txt'){
      // 文本
      src = 'assets/Images/files/txt.png'
    }else if(fileSuffix == 'zip'){
      // 压缩包
      src = 'assets/Images/files/zip.png'
    } else{
      //未知文件类型
      src = 'assets/Images/files/null.png'
    }
    return src
  }
}
